import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { InjectSolarComponent } from './inject-solar/inject-solar.component';
import { DashboardComponent } from './inject-solar/dashboard/dashboard.component';
import { HeaderComponent } from './inject-solar/header/header.component';
import { FooterComponent } from './inject-solar/footer/footer.component';
import { DevicesComponent } from './inject-solar/dashboard/devices/devices.component';
import { ReportsComponent } from './inject-solar/dashboard/reports/reports.component';
import { DataService } from './data-service/data.service';
import { HttpInterceptorsService } from './data-service/http-interceptors.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {HttpClientModule} from '@angular/common/http';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { ProfileComponent } from './inject-solar/dashboard/profile/profile.component';
import { BsDropdownModule, ModalModule,  DatepickerModule } from 'ngx-bootstrap';
import { AuthService } from './auth/auth.service';
import { ChangePasswordComponent } from './inject-solar/dashboard/change-password/change-password.component';
import { DashboardService } from './inject-solar/dashboard/dashboard.service';
import { EpcUsersComponent } from './inject-solar/dashboard/epc-users/epc-users.component';
import { NormalUsersComponent } from './inject-solar/dashboard/normal-users/normal-users.component';
import { WmsUsersComponent } from './inject-solar/dashboard/wms-users/wms-users.component';
import { AddDeviceComponent } from './inject-solar/dashboard/add-device/add-device.component';
import { AddEpcComponent } from './inject-solar/dashboard/add-epc/add-epc.component';
import { AddNormalUserComponent } from './inject-solar/dashboard/add-normal-user/add-normal-user.component';
import { AddWmsUserComponent } from './inject-solar/dashboard/add-wms-user/add-wms-user.component';
import { RegisterDeviceComponent } from './inject-solar/dashboard/register-device/register-device.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlarmsComponent } from './inject-solar/dashboard/alarms/alarms.component';
import { HighchartsChartComponent, HighchartsChartModule } from 'highcharts-angular';
//import { WmsUsersDevicesComponent } from './inject-solar/dashboard/epc-users-reports/epc-users-reports.component';
import { SystemDetailsComponent } from './inject-solar/dashboard/system-details/system-details.component';
import { ErroreLogComponent } from './inject-solar/dashboard/errore-log/errore-log.component';
import { InverterDetailsComponent } from './inject-solar/dashboard/inverter-details/inverter-details.component';
import { MpptDataComponent } from './inject-solar/dashboard/mppt-data/mppt-data.component';
import { RegisterDeviceWmsuserComponent } from './inject-solar/dashboard/register-device-wmsuser/register-device-wmsuser.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { ChartModule } from 'angular-highcharts';
import { MatFormFieldModule, MatCheckboxModule, MatSelectModule, MatOptionModule, MatTooltipModule, MatIconModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import {MatNativeDateModule} from '@angular/material';
import { CustomDatepickerModule } from './inject-solar/dashboard/custom-datepicker/custom-datepicker.module';
import { LoaderService } from './inject-solar/dashboard/shared.service';
import { HighchartsService } from './inject-solar/dashboard/highchart.service';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { EpcUserReportsComponent } from './inject-solar/dashboard/epc-user-reports/epc-user-reports.component';
import { TopHeaderComponent } from './inject-solar/top-header/top-header.component';
import { SensorDataComponent } from './inject-solar/dashboard/sensor-data/sensor-data.component';
import { WmsReportComponent } from './inject-solar/dashboard/wms-report/wms-report.component';
import { WmsInverterDataComponent } from './inject-solar/dashboard/wms-inverter-data/wms-inverter-data.component';
import { ReplaceDeviceComponent } from './inject-solar/dashboard/replace-device/replace-device.component';
import { BlogAndNotificationComponent } from './inject-solar/dashboard/blog-and-notification/blog-and-notification.component';
import { PortalSubscriptionComponent } from './inject-solar/dashboard/portal-subscription/portal-subscription.component';
import { WmsErrorLogComponent } from './inject-solar/dashboard/wms-error-log/wms-error-log.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTabsModule} from '@angular/material/tabs';
import { MatLinkPreviewModule } from '@angular-material-extensions/link-preview';
import {
  NgxUiLoaderModule,
  NgxUiLoaderHttpModule,
  NgxUiLoaderRouterModule,
  NgxUiLoaderConfig,
  SPINNER,
  POSITION,
  PB_DIRECTION
} from 'ngx-ui-loader';
import { AdminUserRegistrationComponent } from './inject-solar/dashboard/admin-user-registration/admin-user-registration.component';
import { SlaveAdminComponent } from './inject-solar/dashboard/slave-admin/slave-admin.component';
import { AddSlaveAdminComponent } from './inject-solar/dashboard/add-slave-admin/add-slave-admin.component';
import { InverterGainTableComponent } from './inject-solar/dashboard/inverter-gain-table/inverter-gain-table.component';
import { AddInverterGainComponent } from './inject-solar/dashboard/add-inverter-gain/add-inverter-gain.component';
import { AdminWmsUsersComponent } from './inject-solar/dashboard/admin-wms-users/admin-wms-users.component';
import { AdminNormalUsersComponent } from './inject-solar/dashboard/admin-normal-users/admin-normal-users.component';
import { AddAdminWmsUsersComponent } from './inject-solar/dashboard/add-admin-wms-users/add-admin-wms-users.component';
import { AddAdminNormalUsersComponent } from './inject-solar/dashboard/add-admin-normal-users/add-admin-normal-users.component';
import { RegisterEpcUsersComponent } from './inject-solar/dashboard/register-epc-users/register-epc-users.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { RegisterWmsusersDeviceByadminComponent } from './inject-solar/dashboard/register-wmsusers-device-byadmin/register-wmsusers-device-byadmin.component';
import { RegisterNormalusersDeviceByadminComponent } from './inject-solar/dashboard/register-normalusers-device-byadmin/register-normalusers-device-byadmin.component';
import { SafePipe } from './safe.pipe';
import { EpcBlogAndNotificationComponent } from './inject-solar/dashboard/epc-blog-and-notification/epc-blog-and-notification.component';
import { UserSubscriptionDilogComponent } from './inject-solar/dashboard/user-subscription-dilog/user-subscription-dilog.component';
import { ErrorLogAdminComponent } from './error-log-admin/error-log-admin.component';
import { environment } from 'src/environments/environment';
import { BnNgIdleService } from 'bn-ng-idle';
import { EnergyMeterComponent } from './inject-solar/dashboard/energy-meter/energy-meter.component';
import { EnergyMeterNormalComponent } from './inject-solar/dashboard/energy-meter-normal/energy-meter-normal.component';
import { AdminZeUsersComponent } from './inject-solar/dashboard/admin-ze-users/admin-ze-users.component';
import { AdminDgUsersComponent } from './inject-solar/dashboard/admin-dg-users/admin-dg-users.component';
import { AddAdminZeUsersComponent } from './inject-solar/dashboard/add-admin-ze-users/add-admin-ze-users.component';
import { AddAdminDgUsersComponent } from './inject-solar/dashboard/add-admin-dg-users/add-admin-dg-users.component';
import { RegisterZeusersDeviceByadminComponent } from './inject-solar/dashboard/register-zeusers-device-byadmin/register-zeusers-device-byadmin.component';
import { RegisterDgusersDeviceByadminComponent } from './inject-solar/dashboard/register-dgusers-device-byadmin/register-dgusers-device-byadmin.component';
import { EpcDgUsersComponent } from './inject-solar/dashboard/epc-dg-users/epc-dg-users.component';
import { EpcZeUsersComponent } from './inject-solar/dashboard/epc-ze-users/epc-ze-users.component';
import { EpcDeviceDgUsersComponent } from './inject-solar/dashboard/epc-device-dg-users/epc-device-dg-users.component';
import { EpcDeviceZeUsersComponent } from './inject-solar/dashboard/epc-device-ze-users/epc-device-ze-users.component';
import { AddEpcZeUserComponent } from './inject-solar/dashboard/add-epc-ze-user/add-epc-ze-user.component';
import { AddEpcDgUserComponent } from './inject-solar/dashboard/add-epc-dg-user/add-epc-dg-user.component';
import { PdfComponent } from './auth/pdf/pdf.component';
import { ErrorLogComponent } from './inject-solar/dashboard/error-log/error-log.component';
import { AddErrorLogComponent } from './inject-solar/dashboard/add-error-log/add-error-log.component';
import { HighchartComponent } from './inject-solar/dashboard/highchart/highchart.component'; // import bn-ng-idle service
import {MatMenuModule} from '@angular/material/menu';
import { AddStringPopupComponent } from './inject-solar/dashboard/add-string-popup/add-string-popup.component';
import { AddMpptStringComponent } from './inject-solar/dashboard/add-mppt-string/add-mppt-string.component';
import { ThirdPartyUsersComponent } from './inject-solar/dashboard/third-party-users/third-party-users.component';
import { AddThirdPartyApiComponent } from './inject-solar/dashboard/add-third-party-api/add-third-party-api.component';
import { EpcDashboardComponent } from './inject-solar/dashboard/epc-dashboard/epc-dashboard.component';
import { ReusableTableComponent } from './inject-solar/dashboard/reusable-table/reusable-table.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  // bgsColor: 'blue',
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 80,
  fgsSize: 100,
  bgsType: SPINNER.fadingCircle,// background spinner type
  fgsType: SPINNER.fadingCircle, // foreground spinner type
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 7, // progress bar thicknes
};



@NgModule({
  declarations: [

    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    InjectSolarComponent,
    DashboardComponent,
    HeaderComponent,
    FooterComponent,
    DevicesComponent,
    ReportsComponent,
    AlarmsComponent,
    ProfileComponent,
    ChangePasswordComponent,
    EpcUsersComponent,
    NormalUsersComponent,
    WmsUsersComponent,
    AddDeviceComponent,
    AddEpcComponent,
    AddNormalUserComponent,
    AddWmsUserComponent,
    RegisterDeviceComponent,
  //  HighchartsChartComponent,

   // WmsUsersDevicesComponent,
    SystemDetailsComponent,
    ErroreLogComponent,
    InverterDetailsComponent,
    MpptDataComponent,
    RegisterDeviceWmsuserComponent,
    EpcUserReportsComponent,
    TopHeaderComponent,
    SensorDataComponent,
    WmsReportComponent,
    WmsInverterDataComponent,
    ReplaceDeviceComponent,
    BlogAndNotificationComponent,
    PortalSubscriptionComponent,
    WmsErrorLogComponent,
    AdminUserRegistrationComponent,
    SlaveAdminComponent,
    AddSlaveAdminComponent,
    InverterGainTableComponent,
    AddInverterGainComponent,
    AdminWmsUsersComponent,
    AdminNormalUsersComponent,
    AddAdminWmsUsersComponent,
    AddAdminNormalUsersComponent,
    RegisterEpcUsersComponent,
    ConfirmationDialogComponent,
    RegisterWmsusersDeviceByadminComponent,
    RegisterNormalusersDeviceByadminComponent,
    SafePipe,
    EpcBlogAndNotificationComponent,
    UserSubscriptionDilogComponent,
    ErrorLogAdminComponent,
    EnergyMeterComponent,
    EnergyMeterNormalComponent,
    AdminZeUsersComponent,
    AdminDgUsersComponent,
    AddAdminZeUsersComponent,
    AddAdminDgUsersComponent,
    RegisterZeusersDeviceByadminComponent,
    RegisterDgusersDeviceByadminComponent,
    EpcDgUsersComponent,
    EpcZeUsersComponent,
    EpcDeviceDgUsersComponent,
    EpcDeviceZeUsersComponent,
    AddEpcZeUserComponent,
    AddEpcDgUserComponent,
    PdfComponent,
    ErrorLogComponent,
    AddErrorLogComponent,
    HighchartComponent,
    AddStringPopupComponent,
    AddMpptStringComponent,
    ThirdPartyUsersComponent,
    AddThirdPartyApiComponent,
    EpcDashboardComponent,
    ReusableTableComponent

   ],
  imports: [

    MatSlideToggleModule,
    NgbModule,
    ChartModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    CustomDatepickerModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatOptionModule,
    DatepickerModule,
    MatDatepickerModule,
    MatIconModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HighchartsChartModule,
    MatToolbarModule,
    MatTabsModule,
    MatSelectModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule,
    MatLinkPreviewModule.forRoot(),
    NgxUiLoaderHttpModule.forRoot({exclude: [environment.apiBase + '/epc/Epc/getDeviceDataOfUsers',environment.apiBase + '/epc/Epc/totalEnergyGeneratedEPC',environment.apiBase + '/admin/Admin/totalEnergyGeneratedAdmin',environment.apiBase+'/admin/Admin/getDeviceDataOfUsers', environment.apiBase+'/normal/Alarms/getDeviceStatus'] ,showForeground: true }),

  ],

  exports: [

    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatIconModule,
    MatFormFieldModule],
    providers: [DataService, HttpInterceptorsService,AuthService, DashboardService,BnNgIdleService,
    LoaderService, HighchartsService,{
    provide: HTTP_INTERCEPTORS,
    useClass: HttpInterceptorsService,
    multi: true,
  }],

  bootstrap: [AppComponent],
  entryComponents: [ConfirmationDialogComponent,UserSubscriptionDilogComponent]
})
export class AppModule { }
